// Servicio picking - Sprint 36.
import apiClient from '../../../api/apiClient';

const B = '/picking';

export async function listPickings({ page = 1, per_page = 25, estado = '', q = '' } = {}) {
  const p = new URLSearchParams();
  p.set('page', page); p.set('per_page', per_page);
  if (estado) p.set('estado', estado);
  if (q) p.set('q', q);
  const r = await apiClient.get(B + '/?' + p.toString());
  const d = (r && r.data) || {};
  return { items: d.items || [], total: d.total || 0 };
}

export async function getPicking(id) {
  const r = await apiClient.get(B + '/' + id);
  return (r && r.data) || null;
}

export async function scanPicking(id, code) {
  const r = await apiClient.post(B + '/' + id + '/scan', { code });
  return (r && r.data) || null;
}

export async function ajustarLinea(pid, lid, payload) {
  const r = await apiClient.put(B + '/' + pid + '/linea/' + lid, payload);
  return (r && r.data) || null;
}

export async function completarPicking(id) {
  const r = await apiClient.post(B + '/' + id + '/completar', {});
  return (r && r.data) || null;
}
